export default __webpack_public_path__ + "locales/tr/ConvertDialog.json?hash=6a6bf237ef67d0e4c7416fa31a144fcb";